import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
//import React from 'react'
import DesktopSidebar from "./DesktopSidebar";
import MobileSidebar from "./MobileSidebar";
function Sidebar() {
    return (_jsxs(_Fragment, { children: [_jsx(DesktopSidebar, {}), _jsx(MobileSidebar, {})] }));
}
export default Sidebar;
